<template>
  <div class="errorPage">
    <h2>ThngId not recognised</h2>
  </div>
</template>
<script>
    export default {

    };
</script>
<style lang="scss" scoped>
  .errorPage {
    height: 100vh;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
  }
</style>
